module.exports = __webpack_public_path__ + "static/img/card_5_1.5023339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_5_1.png
// module id = Ut1A
// module chunks = 0